export default __webpack_public_path__ + "static/media/xls.61525364.png";